import { color } from '@/colors';
import { StickyNoteSize, type StickyNoteData } from '@/types/node';
import { FlowGraph } from '../FlowGraph';
import type { NodeId } from 'web';

export { StickyNoteSize };

interface StickyNoteSizeConfig {
  fontSize: number;
  padding: number;
  width: number;
  minRows: number;
}

export const STICKY_NOTE_SIZE_CONFIG: Record<StickyNoteSize, StickyNoteSizeConfig> = {
  [StickyNoteSize.SM]: { fontSize: 16, padding: 16, width: 240, minRows: 9 },
  [StickyNoteSize.MD]: { fontSize: 48, padding: 32, width: 480, minRows: 5 },
  [StickyNoteSize.LG]: { fontSize: 144, padding: 64, width: 960, minRows: 1 },
};

const DEFAULT_SIZE = StickyNoteSize.SM;

export const LEGACY_FONT_SIZE_TO_SIZE = new Map<number, StickyNoteSize>([
  [16, StickyNoteSize.SM],
  [24, StickyNoteSize.SM],
  [32, StickyNoteSize.MD],
]);

export const DEFAULT_STICKY_NOTE_COLOR = color.Black16;

export class StickyNoteView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  updateColor(color: string): void {
    this.graph.edit(() => {
      return this.graph.updateNodeData(this.nodeId, { color });
    });
  }

  updateSize(size: StickyNoteSize): void {
    this.graph.edit(() => {
      return this.graph.store.updateNodeData<StickyNoteData>(this.nodeId, () => ({
        size,
      }));
    });
  }

  updateNote(note: string): void {
    this.graph.edit(() => {
      return this.graph.store.updateNodeData<StickyNoteData>(this.nodeId, (data) => ({
        result: { ...(data.result ?? {}), note },
      }));
    });
  }

  getColor(): string | undefined {
    return this.graph.store.getNodeDataNullable<StickyNoteData>(this.nodeId)?.color;
  }

  getSize(): StickyNoteSize {
    const data = this.graph.store.getNodeDataNullable<StickyNoteData>(this.nodeId);

    return data?.size || DEFAULT_SIZE;
  }
}
